import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import axios from "axios";
import { useUserState } from "../../../Contexts/UserContext";
import DeleteConfirm from "../../DeleteConfirm";
export default function MonthsAccordion({ categoryId, categoryName }) {
  const { user } = useUserState();
  const [activeMonth, setActiveMonth] = useState("3");
  const [packages, setPackages] = useState([]);
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState(false);
  const [packId, setPackId] = useState(null);
  const [delLoader, setDelLoader] = useState(false);
  const fetchPackages = async () => {
    const headersFormData = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };
    if (user?.token) {
      // setIsLoader(true);
      try {
        let res = await axios.get(
          `${
            import.meta.env.VITE_APP_BASE_URL
          }/api/package/get-package-list?categoryId=${categoryId}&leasePeriod=${activeMonth}`,
          { headers: headersFormData }
        );
        setPackages(res.data.data);
      } catch (err) {
        // setIsLoader(false);
        return console.log(err);
      }
    }
  };
  useEffect(() => {
    fetchPackages();
  }, [categoryId, activeMonth]);

  const handleAddPackageClick = (leasePeriod) => {
    navigate("/user_dash/furniture_company/add_package", {
      state: { leasePeriod, categoryId, categoryName },
    });
  };
  const handleEditPackageClick = (EditPackageId, leasePeriod) => {
    navigate("/user_dash/furniture_company/add_package", {
      state: { EditPackageId, leasePeriod, categoryId, categoryName },
    });
  };

  const handleFurnitureSelect = (e) => {
    const options = Array.from(e.target.selectedOptions);
    const ids = options.map((opt) => parseInt(opt.value, 10));
    setSelectedFurnitureIds(ids);
  };

  const handleDeletePackage = async () => {
    const headersFormData = {
      "Content-Type": "application/json",
      Authorization: user?.token,
    };
    setDelLoader(true);
    try {
      const res = await axios.delete(
        `${import.meta.env.VITE_APP_BASE_URL}/api/package/delete/${packId}`,
        { headers: headersFormData }
      );
      fetchPackages();
    } catch (err) {
      console.error("Error saving package:", err);
      alert(`Failed to ${isEdit ? "update" : "save"} package`);
    } finally {
      setDelLoader(false);
      setDeleteModal(false);
    }
  };
  return (
    <div className="accordion" style={{ width: "100%" }}>
      {["3", "6", "12"].map((month) => (
        <div key={month} className="accordion-item">
          <h2 className="accordion-header">
            <button
              className={`accordion-button monthsBtn ${
                activeMonth === month ? "active" : "collapsed"
              }`}
              type="button"
              onClick={() => setActiveMonth(month)}
            >
              {month} Months
            </button>
          </h2>

          {activeMonth === month && (
            <div className="accordion-collapse show">
              <div className="accordion-body">
                <div className="d-flex justify-content-end mb-3">
                  <button
                    type="button"
                    className="btn btn-primary"
                    style={{ width: "15%", backgroundColor: "#0474ba" }}
                    onClick={() => handleAddPackageClick(month)}
                  >
                    Add package
                  </button>
                </div>

                {packages.filter((pkg) => pkg.lease_period == month).length >
                0 ? (
                  <div className="furniture_store table-responsive">
                    <table className="table m-0">
                      <thead>
                        <tr>
                          <th>Bedrooms</th>
                          <th>Bathrooms</th>
                          <th>Furniture Price</th>
                          <th>Houseware Price</th>
                          <th>Total Price</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {packages
                          .filter((pkg) => pkg.lease_period == month)
                          .map((pkg) => (
                            <tr key={pkg.id}>
                              <td>{pkg.bedrooms}</td>
                              <td>{pkg.bathrooms}</td>
                              <td>
                                {pkg.furnitureTotal ? pkg.furnitureTotal : "-"}
                              </td>
                              <td>
                                {pkg.housewareTotal ? pkg.housewareTotal : "-"}
                              </td>
                              <td>{pkg.totalPrice ? pkg.totalPrice : "-"}</td>
                              <td>
                                <div className="d-flex gap-1">
                                  <Button
                                    variant="outline-primary"
                                    size="sm"
                                    title="Edit package"
                                    onClick={() =>
                                      handleEditPackageClick(pkg?.id, month)
                                    }
                                  >
                                    Edit
                                  </Button>
                                  <Button
                                    variant="outline-danger"
                                    size="sm"
                                    title="Delete package"
                                    onClick={() => {
                                      setDeleteModal(true), setPackId(pkg?.id);
                                    }}
                                  >
                                    <i className="fas fa-trash"></i>
                                  </Button>
                                </div>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p>No packages for {month} months</p>
                )}
              </div>
            </div>
          )}
        </div>
      ))}
      <DeleteConfirm
        deleteModal={deleteModal}
        setDeleteModal={setDeleteModal}
        handleDelete={handleDeletePackage}
        setDelLoader={setDelLoader}
        delLoader={delLoader}
        title="Package"
      />
    </div>
  );
}
